
import { updateDiagramNodeShape, getDiagramNodeShape } from '@process-advisor/process-miner/processMiner/processMiner';

export type NodeShapeProps = {
    node_shape?: string;
}

export const changeNodeShape = ({ node_shape }: NodeShapeProps) => {
    updateDiagramNodeShape({ node_shape });
}

export const getNodeShape = () => getDiagramNodeShape();
